import { F, compose } from 'ramda'
import { componentDidMount, shouldComponentUpdate } from '../../components/Lifecycles'
import View from './TikTok'
import { connect } from 'react-redux'
import { injectTikTokSchema } from '../../store/modules/header'

// mapStateToProps :: State -> Props
const mapStateToProps = state => ({
  locale: state.router.locale,
})

// mapDispatchToProps :: (Action * -> State) -> Prop
const mapDispatchToProps = dispatch => ({
  injectTikTokSchema: compose(dispatch, injectTikTokSchema),
})

// didMount :: Props -> State
const didMount = ({ injectTikTokSchema, sourceUrl, src, uploadDate }) => injectTikTokSchema(sourceUrl, src, uploadDate)

// lifecycles :: React.Component -> React.Component
const lifecycles = compose(
  componentDidMount(didMount),
  shouldComponentUpdate(F),
)(View)

// TikTok :: Props -> React.Component
const TikTok = connect(mapStateToProps, mapDispatchToProps)(lifecycles)

export default TikTok
